const twoFactorAuth = {
  verifyIdentity: "Wir überprüfen Ihre Identität",
  enterOtpMessage:
    "Bitte geben Sie den 6-stelligen Code, den Sie per E-Mail erhalten haben, in das untenstehende Feld ein.",
  verifyCode: "Bestätigungscode",
  codeExpiry: "Der erhaltene Code läuft nach 5 Minuten ab.",
  sendNewEmail: "Verifizierungs-E-Mail erneut senden",
};

export default twoFactorAuth;
